import React from 'react';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import PeopleGroupIconLegacy from '@atlaskit/icon/glyph/people-group';
import type { GroupShare } from '@atlassian/jira-shared-types/src/share-permission.tsx';
import { NameWrapper, IconWrapper } from '../common/styled.tsx';

type Props = {
	sharePermission: GroupShare;
};

export default function GroupName({ sharePermission: { group } }: Props) {
	return (
		<>
			<IconWrapper>
				<PeopleGroupIcon label="" spacing="spacious" LEGACY_fallbackIcon={PeopleGroupIconLegacy} />
			</IconWrapper>
			<NameWrapper>{group.name}</NameWrapper>
		</>
	);
}
